<template>
  <div class="todo">
    <div class="wrap todo-main">
      <el-card shadow="never">
        <div class="todo-header">
          <div class="todo-title">
            <div class="todo-title-left">
              <div class="todo-title-left-text">我的未学习课程</div>
            </div>
            <!-- <div class="todo-title-right">
              <div class="todo-title-right-text">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                  <el-tab-pane label="卡片模式" name="first"></el-tab-pane>
                  <el-tab-pane label="日程模式" name="second"></el-tab-pane>
                </el-tabs>
              </div>
            </div> -->
          </div>
        </div>
        <div class="todo-content">
          <!-- <div class="first-content" v-if="activeName === 'first'">
            <div class="subject">
              <img src="@/assets/imgs/bgi42.png" alt="">
              <div class="subject-title-task">
                <div class="subject-title">自选课程</div>
                <div class="subject-task">任务数：<span>4</span></div>
              </div>
            </div>
          </div> -->
          <div class="second-content">
            <!-- <div class="calendar-area">
              <el-calendar>
                <template
                    slot="dateCell"
                    slot-scope="{date, data}">
                  <span>
                      {{ data.day.split('-').slice(2).join('-') }}
                  </span>
                </template>
              </el-calendar>
            </div> -->
            <div class="schedule-area">
              <!-- <div class="schedule-header">
                <div class="schedule-title">07-17 <span>4</span></div>
                <div class="schedule-radio">
                  <el-radio v-model="radio" :label="1" checked>学习/培训任务</el-radio>
                </div>
              </div> -->
              <div class="schedule-content" style="--task-generete-primary-color: rgba(250, 84, 28,0.06);">
                <div class="schedule-item" v-for="item in coursesList" :key="item.id" @click="openMyCourse(item)">
                  <div class="schedule-item-left">
                    <img src="@/assets/imgs/bgi42.png" alt="">
                    <div class="subject-infos">
                      <div>【{{ item.isRequired===1?'必修':'选修' }}课程】{{ item.courseTitle }}</div>
                      <span>观看课程</span>
                    </div>
                    <div class="subject-type">课程类型：{{ item.isRequired===1?'必修':'选修' }}</div>
                  </div>
                  <div class="schedule-item-right">
                    <span></span>
                    <span>{{item.schedule}}%</span>
                  </div>
                </div>
                <!-- <div class="schedule-item">
                  <div class="schedule-item-left">
                    <img src="@/assets/imgs/bgi42.png" alt="">
                    <div class="subject-infos">
                      <div>【自选课程】建筑</div>
                      <span>结业条件：课程学习</span>
                    </div>
                    <div class="subject-type">课程类型：自选</div>
                  </div>
                  <div class="schedule-item-right">
                    <span></span>
                    <span>0%</span>
                  </div>
                </div>
                <div class="schedule-item">
                  <div class="schedule-item-left">
                    <img src="@/assets/imgs/bgi42.png" alt="">
                    <div class="subject-infos">
                      <div>【自选课程】机电</div>
                      <span>结业条件：课程学习</span>
                    </div>
                    <div class="subject-type">课程类型：自选</div>
                  </div>
                  <div class="schedule-item-right">
                    <span></span>
                    <span>0%</span>
                  </div>
                </div>
                <div class="schedule-item">
                  <div class="schedule-item-left">
                    <img src="@/assets/imgs/bgi42.png" alt="">
                    <div class="subject-infos">
                      <div>【自选课程】公路</div>
                      <span>结业条件：课程学习</span>
                    </div>
                    <div class="subject-type">课程类型：自选</div>
                  </div>
                  <div class="schedule-item-right">
                    <span></span>
                    <span>0%</span>
                  </div>
                </div> -->

              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { getMyCourses } from '@/api/course'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data() {
    return {
      activeName: 'first',
      value: '',
      radio: 1,
      coursesList:[]
    }
  },
  created() {
    // 获取我的已购课程
    this.getMyCourses()
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 获取我的已购课程
    async getMyCourses() {
      try {
        const params = {
          page:1,
          limit:10,
          is_required:-1,
          status:0
        }
        const res = await getMyCourses(params)
        this.coursesList = res.data
      } catch (error) {
        console.log(error);
      }
    },
    // 跳转到课程详情
    openMyCourse(item){
      let routeData = this.$router.resolve({
        name: 'detail',
        query:{coursesId:item.courseId}
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>


<style scoped lang="scss">
.todo {
  .todo-main {
    .todo-header {
      .todo-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        border-bottom: 1px solid #e9e9e9;

        .todo-title-left {
          color: #333;
          font-size: 16px;
          font-weight: 700;
        }

        .todo-title-right {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }

    }
  }
}

.more {
  margin-left: 24px;
  font-size: 14px;
  color: #558ad6;
  cursor: pointer;
}

::v-deep .el-tabs__header.is-top {
  margin: 0;
}

::v-deep .el-tabs__item {
  padding: 0 14px;
  height: 30px;
  line-height: 30px;
}

.todo-content {
  .first-content {
    width: 100%;

    .subject {
      width: 20%;
      display: flex;
      align-items: center;
      padding: 18px;
      cursor: pointer;
      border-right: 1px solid #e9e9e9;

      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
    }

    .subject:hover {
      box-shadow: 0 0 10px 2px #e9e9e9;
    }

    .subject-title-task {
      margin-left: 10px;
      text-align: center;

      .subject-title {
        margin-bottom: 10px;
        font-size: 15px;
        color: #666;
      }

      .subject-task {
        font-size: 14px;
        color: #999;

        span {
          color: #000;
        }
      }
    }
  }

  .second-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    padding-right: 30px;

    .calendar-area {
      width: 20%;
      font-size: 13px;
      color: #000;

      ::v-deep .el-button-group button {
        padding: 2px 5px;
      }

      ::v-deep .el-button-group button:nth-child(2) {
        display: none;
      }

      ::v-deep .el-calendar-table .el-calendar-day {
        height: auto;
      }

      ::v-deep .el-calendar-table td {
        border: none;
      }
    }

    .schedule-area {
      width: 100%;
      // margin-left: 20px;

      .schedule-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .schedule-title {
          font-size: 15px;
          color: #222;
          font-weight: 700;

          span {
            display: inline-block;
            width: 16px;
            height: 16px;
            font-size: 14px;
            background-color: #e9e9e9;
            color: #333;
            border-radius: 50%;
            line-height: 16px;
            text-align: center;
          }
        }
      }

      .schedule-content {
        height: 200px;
        overflow: auto;
        cursor: pointer;
        padding-top: 10px;

        .schedule-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 10px 20px;
          margin-bottom: 10px;
          background-color: #F7E6E0;
          border-radius: 6px;

          .schedule-item-left {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex: 1;

            img {
              width: 28px;
              height: 28px;
              margin-right: 20px;
              border-radius: 50%;
            }

            .subject-infos {
              width: 300px;
              font-size: 14px;
              color: #222;
              text-align: left;

              div {
                margin-bottom: 6px;
              }

              span {
                font-size: 14px;
                color: #999;
              }
            }

            .subject-type {
              margin-left: 60px;
              font-size: 14px;
              color: #999;
            }
          }

          .schedule-item-right {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 20%;
            text-align: right;
            font-size: 14px;
            color: #666;

            span:first-child {
              position: relative;
              display: inline-block;
              width: 8px;
              height: 8px;
              margin-right: 6px;
              background-color: #558ad6;
              border-radius: 50%;

            }

            span:first-child::after {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: 1px solid #558ad6;
              border-radius: 50%;
              -webkit-animation: antStatusProcessing 1.2s ease-in-out infinite;
              animation: antStatusProcessing 1.2s ease-in-out infinite;
              content: "";
            }

            @keyframes antStatusProcessing {
              0% {
                -webkit-transform: scale(.8);
                transform: scale(.8);
                opacity: .5;
              }
              100% {
                -webkit-transform: scale(2.4);
                transform: scale(2.4);
                opacity: 0;
              }
            }
          }
        }
      }

      .schedule-content::-webkit-scrollbar {
        width: 8px; /* 设置滚动条宽度 */
        border-radius: 4px;
      }

      .schedule-content::-webkit-scrollbar-track {
        background: #f1f1f1; /* 滚动条轨道颜色 */
        width: 8px;
        border-radius: 4px;
      }

      .schedule-content::-webkit-scrollbar-thumb {
        background: #bbb; /* 滚动条手柄颜色 */
        width: 8px;
        border-radius: 4px;
      }

      .schedule-content::-webkit-scrollbar-thumb:hover {
        background: #999; /* 滚动条手柄hover颜色 */
        width: 8px;
        border-radius: 4px;
      }

    }
  }

}

::v-deep .el-card__body {
  padding: 0;
}

.todo-title-left-text{
  color: #558ad6;
}
</style>
